var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_12885)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.379816 7.75579L19.1461 0.560155C19.2531 0.507208 19.3736 0.487724 19.4918 0.50426C19.61 0.520795 19.7205 0.572577 19.8087 0.652817C19.8969 0.733057 19.9587 0.83801 19.9861 0.953916C20.0135 1.06982 20.0051 1.19127 19.9621 1.30234L12.7819 20.1191C12.7408 20.2273 12.6688 20.3211 12.5747 20.3889C12.4806 20.4566 12.3687 20.4953 12.2528 20.5002C12.1368 20.505 12.022 20.4758 11.9226 20.4162C11.8232 20.3565 11.7435 20.2691 11.6935 20.1646L9.05639 14.7233C8.89822 14.3969 8.92915 14.0105 9.13722 13.7134L11.3128 10.6075C11.9538 9.69228 10.8394 8.57464 9.92236 9.21307L6.8168 11.3752C6.52165 11.5807 6.1389 11.6119 5.81439 11.4569L0.335756 8.83978C0.231508 8.7898 0.144209 8.71048 0.0846305 8.6116C0.0250522 8.51272 -0.00419891 8.39861 0.000486324 8.28334C0.00517155 8.16807 0.0435881 8.05669 0.110996 7.96295C0.178404 7.8692 0.271854 7.79719 0.379816 7.75579Z",
    fill: "url(#paint0_linear_213_12885)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_12885",
    x1: 7.36192,
    y1: 5.53356,
    x2: 24.9589,
    y2: 26.3408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_12885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.97f1fddef48446893885d2b9e3905758.svg";
export { ForwardRef as ReactComponent };